import React from 'react';
import BaseWithoutNavBarLayout from "./baseWithoutNavBarLayout";

const LandingLayout = ({ children }) => {
    return (
        <BaseWithoutNavBarLayout>
            {children}
        </BaseWithoutNavBarLayout>
    );
};

export default LandingLayout;
